const LINE_ITEMS_FRAGMENT = `
#graphql
fragment LineItemsFragment on Cart {
  lines(first: 250) {
    edges {
      node {
        id
        quantity
        merchandise {
          ... on ProductVariant {
            id
            title
            image {
              src
              altText
            }
            price {
              amount
              currencyCode
            }
            product {
              title
            }
          }
        }
        sellingPlanAllocation {
          sellingPlan {
            id
            name
            deliveryPolicy {
              ... on SellingPlanRecurringDeliveryPolicy {
                interval
                intervalCount
              }
            }
          }
        }
      }
    }
  }
  discountAllocations {
    discountedAmount {
      amount
      currencyCode
    }
  }
  discountCodes {
    applicable
    code
  }
  cost {
    totalAmount {
      amount
      currencyCode
    }
    subtotalAmount {
      amount
      currencyCode
    }
    totalTaxAmount {
      amount
      currencyCode
    }
    totalDutyAmount {
      amount
      currencyCode
    }
  }
}
`

export const CART_LINES_ADD_OPERATION = `
#graphql
mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      id
      checkoutUrl
      updatedAt
      ...LineItemsFragment
    }
  }
}
${LINE_ITEMS_FRAGMENT}
`

export const CART_LINES_REMOVE_OPERATION = `
#graphql
mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      id
      checkoutUrl
      updatedAt
      ...LineItemsFragment
    }
  }
}
${LINE_ITEMS_FRAGMENT}
`

export const GET_CART_OPERATION = `
#graphql
query getCart($id: ID!) {
  cart(id: $id) {
    id
    checkoutUrl
    updatedAt
    ...LineItemsFragment
  }
}
${LINE_ITEMS_FRAGMENT}
`

export const CART_LINES_UPDATE_OPERATION = `
#graphql
mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      id
      checkoutUrl
      updatedAt
      ...LineItemsFragment
    }
  }
}
${LINE_ITEMS_FRAGMENT}
`

export const CART_CREATE_OPERATION = `
#graphql
mutation createCart($cartInput: CartInput) {
  cartCreate(input: $cartInput) {
    cart {
      id
      checkoutUrl
      updatedAt
      ...LineItemsFragment
    }
  }
}
${LINE_ITEMS_FRAGMENT}
`

export const CART_DISCOUNT_CODE_UPDATE_OPERATION = `
#graphql
mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes:[String!]) {
  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
    cart {
      id
      checkoutUrl
      updatedAt
      ...LineItemsFragment
    }
  }
}
${LINE_ITEMS_FRAGMENT}
`

const PRODUCT_VARIANT_FRAGMENT = `
#graphql
fragment ProductVariantFragment on ProductVariant {
  id
  title
  image {
    url
  }
  priceV2 {
    amount
  }
  compareAtPrice {
    amount
  }
  sellingPlanAllocations(first: 10) {
    edges {
      node {
        sellingPlan {
          id
          name
        }
        priceAdjustments {
          price {
            amount
          }
          compareAtPrice {
            amount
          }
        }
      }
    }
  }
}
`

const PRODUCT_FRAGMENT = `
#graphql
fragment ProductFragment on Product {
  id
  title
  variants(first: 10) {
    edges {
      node {
        ...ProductVariantFragment
      }
    }
  }
}
${PRODUCT_VARIANT_FRAGMENT}
`

export const QUERY_PRODUCTS_OPERATION = `
#graphql
query getProducts {
  products(first: 100) {
    edges {
      node {
        ...ProductFragment
      }
    }
  }
}
${PRODUCT_FRAGMENT}
`
